module.exports = __webpack_public_path__ + "static/media/static-es.41f7d428.png";